import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from '@mui/material/Button';




const BuiltForDevelopers = () => {

    const classes = useStyle();



    return (
        <section className={classes.developers} id="developers">
            <Container>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        <h2>Built With Developers in Mind</h2>
                        <div className={classes.devtext}>
                            <p>Looking to embed digital insurance capabilities into your existing application or build a fully-fledged insurance application? Look no further than ASPin! Our API-first approach means we provide a well-documented, easy-to-use RESTful API that any software developer can integrate with ease. Say goodbye to reinventing the wheel and hello to focusing on the business side of things as we handle the technology infrastructure for you. Get started with ASPin today and see the difference API-first can make!</p>
                            <Button>
                                <a href='https://apidocs.inclusivitysolutions.com/' target='_blank' rel='noopener noreferrer'> View Documentation</a>
                            </Button>
                        </div>

                    </Grid>
                </Grid>
            </Container>
         
        </section>
    )
}

export default BuiltForDevelopers